import { __exports as t } from "../../../../../../_virtual/object-to-query.js";
Object.defineProperty(t, "__esModule", {
  value: !0
});
var r = t.objectToQuery = void 0;
function u(e) {
  return Object.keys(e).map(function (o) {
    return o + "=" + encodeURIComponent(e[o] === void 0 ? "" : e[o]);
  }).join("&");
}
r = t.objectToQuery = u;
export { t as default, r as objectToQuery };
